"use client";

import { ProtectedPage, View } from "@/components";

import {
  VerificationPageHeader,
  VerificationContent,
  VerificationBanner,
  VerificationSteps,
} from "..";

/**
 * VerificationPageView Component
 *
 * Main verification page with view component.
 * Handles verification flow for new users.
 */
export const VerificationPageView = () => {
  return (
    
    <ProtectedPage>
      {/* Main content container */}
      <View>
        {/* Page header with navigation */}
        <VerificationPageHeader />

        {/* Main content area */}
        <VerificationContent>
          {/* Desktop marketing banner */}
          <VerificationBanner />

          {/* Verification steps */}
          <VerificationSteps />
        </VerificationContent>
      </View>
    </ProtectedPage>
  );
};
